import gql from 'graphql-tag';

export const GET_CHANNEL_GROUPS = gql`
    query channelGroups {
        channelGroups {
            _id
            version
            name
            description
            weight
            channelIds
            channelsCount
            createdAt
        }
    }
`;

export const ADD_CHANNEL_GROUP = gql`
    mutation addChannelGroup($item: ChannelGroupInputAdd!) {
        addChannelGroup(item: $item) {
            _id
            version
            name
            description
            weight
            channelsCount
            createdAt
        }
    }
`;

export const GET_CHANNEL_GROUP_BY_ID = gql`
    query findChannelGroupById($id: ID!) {
        findChannelGroupById(id: $id) {
            _id
            version
            name
            description
            weight
        }
    }
`;

export const EDIT_CHANNEL_GROUP = gql`
    mutation editChannelGroup($item: ChannelGroupInputEdit!) {
        editChannelGroup(item: $item) {
            _id
            version
            name
            description
            weight
            channelsCount
            createdAt
        }
    }
`;

export const REORDER_CHANNEL_GROUPS = gql`
    mutation reorderChannelGroups($groupIds: [ID!]!) {
        reorderChannelGroups(groupIds: $groupIds)
    }
`;

export const GET_CHANNEL_GROUPS_FOR_ASSIGNMENT = gql`
    query channelGroupsForAssignment {
        channelGroups {
            _id
            name
            channelIds
        }
    }
`;

export const UPDATE_CHANNEL_GROUP_ASSIGNMENTS = gql`
    mutation updateChannelGroupAssignments(
        $assignments: [ChannelGroupAssignment!]!
    ) {
        updateChannelGroupAssignments(assignments: $assignments)
    }
`;

export const DELETE_CHANNEL_GROUP = gql`
    mutation deleteChannelGroup($id: ID!) {
        deleteChannelGroup(id: $id)
    }
`;

export const REORDER_CHANNELS_IN_GROUPS = gql`
    mutation reorderChannelsInGroups($orders: [ChannelOrderInput!]!) {
        reorderChannelsInGroups(orders: $orders)
    }
`;
